import {IActionBase} from "../../../applyoo/actions/IActionBase";
import {Component} from "react";
import {ActionsManager} from "../../../applyoo/actions/actionsManager";
import {differenceInCalendarDays,endOfDay} from "date-fns";
import {utils_ui} from "../../../applyoo/utils/utils_ui";
import {executeApplyooComponentsFunction} from "../../../applyoo/infrastructure/useApplyooComponent";


export class action_Tasker_SetStartDateTillToday extends Component implements IActionBase {
    actionCode = "action_Tasker_SetStartDateTillToday";
    actionName = "Set Start Date Till Today";

    Execute = (prmActionParameters:any,prmActionsManager:ActionsManager, prmElementObj?:any)=> {
        //
        // let toDT = endOfDay(new Date());
        // let lastModifiedStartDTStr = localStorage["tasksList_ModifySelectedStartDT"];
        // let isSetStartDT = false;
        //
        // if (!!lastModifiedStartDTStr){
        //     let lastModifiedStartDT = new Date(lastModifiedStartDTStr)
        //
        //     if (differenceInCalendarDays(new Date(),lastModifiedStartDT) > 0){
        //         isSetStartDT = true;
        //     }
        // }
        // else{
        //     isSetStartDT = true;
        // }
        //
        // if (isSetStartDT){
        //     let lstParams: any = [];
        //
        //     lstParams.push( {DataBindStr: "Filters.tb_Tasks_List.tb_Tasks_StartDT_To", Value: toDT})
        //     lstParams.push( {DataBindStr: "Filters.tb_Tasks_List.tb_Tasks_IsClosed", Value: false})
        //
        //     executeApplyooComponentsFunction("updateSeveralFieldsInQueryFilter", lstParams)
        //
        //     //utils_ui.setDataItem("Filters.tb_Tasks_List.tb_Tasks_StartDT_To", toDT, true);
        //     localStorage["tasksList_SelectedStartDT"] = toDT.toString();
        //     localStorage["tasksList_ModifySelectedStartDT"] = new Date().toString()
        // }



    }

}